import cx from 'classnames';
import { get } from 'lodash';
import isObject from 'lodash/isObject';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import Select, { components } from 'react-select';

const SelectWithOtherOption = ({ selectedOption, options, setFormData, formKey, placeholder }) => {
  const selectRef = useRef();
  const [otherInputValue, setOtherInputValue] = useState(selectedOption?.otherInputValue || '');

  const resetOtherInputValue = () => {
    setOtherInputValue('');
    selectRef.current.blur();
  };

  const handleChangeValue = (e) => {
    if (e.label !== 'Other') {
      resetOtherInputValue();
    } else {
      setTimeout(() => {
        if (selectRef.current) {
          selectRef.current.focus();
        }
      }, 0);
    }

    setFormData((state) => ({ ...state, [formKey]: e }));
  };

  const handleInputChange = (value) => {
    if (selectedOption?.label === 'Other' && (value || (otherInputValue.length === 1 && value.length === 0))) {
      setOtherInputValue(value);
      setFormData((state) => ({ ...state, [formKey]: { value: 'other', label: 'Other', otherInputValue: value } }));
    }
  };

  const getInputValue = () => {
    if (selectedOption?.label === 'Other') {
      return otherInputValue;
    }

    return selectedOption?.label || '';
  };

  const SingleValue = ({ children, ...props }) => <components.SingleValue {...props} />;

  return (
    <Select
      ref={selectRef}
      options={options}
      components={{ SingleValue }}
      inputValue={getInputValue()}
      className="form-control-select"
      classNames={{ input: () => 'dropdown-input' }}
      classNamePrefix="react-select"
      placeholder={placeholder}
      value={selectedOption}
      filterOption={null}
      onChange={handleChangeValue}
      onInputChange={handleInputChange}
      styles={{
        menu: (provided) => ({
          ...provided,
        }),
        input: (provided) => ({
          ...provided,
          input: {
            opacity: '1 !important',
            marginLeft: '36px',
          },
        }),
        menuList: (provided) => ({
          ...provided,
          minHeight: options.length > 3 ? 168 : undefined,
          maxHeight: 248,
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9 }),
      }}
    />
  );
};

export default SelectWithOtherOption;
